import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { Grid, Typography, Box, makeStyles } from "@material-ui/core";
import { SearchForm } from "./SearchForm";
import { ExpandableContract } from "./ExpandableContract";
import { useIntl } from "react-intl";
import { messages } from "./messages";
import { useResource } from "rest-hooks";
import { DataTable } from "@ploy-ui/core";
import { performContractSearch, isErrorFromSearch } from "./endpoints/ContractSearch";
import { ChangeContractSettingsEndpoint } from "./endpoints/ChangeContractSettings";
export const TypeOfChange = {
    Transfer: "1",
    Modify: "2",
    Extend: "3"
};
const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(8),
        padding: theme.spacing(4)
    }
}));
const ChangeContractInternal = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    const settings = useResource(ChangeContractSettingsEndpoint, {});
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleSearch = useCallback(async function (values, formik) {
        setResult(null);
        setLoading(true);
        let searchArguments = null;
        if (values.contractNumber) {
            searchArguments = {
                searchType: "contractNumber",
                needle: values.contractNumber,
                typeOfChange: props.typeOfChange
            };
        }
        else if (values.regNumber) {
            searchArguments = {
                searchType: "regNum",
                needle: values.regNumber,
                typeOfChange: props.typeOfChange
            };
        }
        if (searchArguments != null) {
            setResult(await performContractSearch(searchArguments));
        }
        setLoading(false);
    }, []);
    return (_jsxs(Grid, { container: true, spacing: 3, className: classes.root, children: [_jsx(Grid, { xs: 12, item: true, children: _jsxs(Grid, { container: true, spacing: 3, justifyContent: "space-between", children: [_jsx(Grid, { xs: 12, md: 8, item: true, children: _jsxs(Typography, { variant: "h3", children: [props.typeOfChange === TypeOfChange.Transfer
                                        ? intl.formatMessage(messages.header_transfer)
                                        : null, props.typeOfChange === TypeOfChange.Modify
                                        ? intl.formatMessage(messages.header_modify)
                                        : null, props.typeOfChange === TypeOfChange.Extend
                                        ? intl.formatMessage(messages.header_extend)
                                        : null, props.typeOfChange == null
                                        ? intl.formatMessage(messages.header)
                                        : null] }) }), _jsx(Grid, { xs: 12, item: true, children: _jsx(SearchForm, { onSearch: handleSearch, hideRegNo: !settings.ShowRegNoSearch }) })] }) }), _jsxs(Grid, { xs: 12, item: true, children: [!loading && result != null && !isErrorFromSearch(result) && (_jsx(DataTable, { options: {
                            search: false,
                            showTitle: false,
                            pageSize: 10,
                            paging: false,
                            emptyRowsWhenPaging: false,
                            toolbar: false
                        }, style: { minHeight: 0 }, onRowClick: (event, rowData, togglePanel) => togglePanel && togglePanel(), columns: [
                            {
                                title: intl.formatMessage(messages.regNumber_short),
                                field: "RegNumber",
                                sorting: false,
                                headerStyle: { paddingRight: 0 }
                            },
                            {
                                title: intl.formatMessage(messages.contractNumber),
                                field: "ContractNumber",
                                sorting: false,
                                headerStyle: { paddingRight: 0 }
                            },
                            {
                                title: intl.formatMessage(messages.customerName),
                                field: "Customer",
                                sorting: false,
                                headerStyle: { paddingRight: 0 }
                            },
                            {
                                title: intl.formatMessage(messages.objectDescription),
                                field: "ObjectOnly",
                                sorting: false,
                                headerStyle: { paddingRight: 0 }
                            },
                            {
                                title: intl.formatMessage(messages.remainingTermsCount),
                                field: "TermsCount",
                                sorting: false,
                                headerStyle: { paddingRight: 0 }
                            }
                        ], data: [result], detailPanel: ({ rowData }) => (_jsx(Box, { p: 2, children: _jsx(ExpandableContract, { expanded: true, typeOfChange: props.typeOfChange, ...rowData }, rowData.ContractNumber) })) })), !loading && result != null && isErrorFromSearch(result) && (_jsxs(_Fragment, { children: [_jsx(Box, { p: 2, children: result.title ?? "" }), _jsx(Box, { p: 2, children: result.detail ?? "" })] }))] })] }));
};
export const ChangeContractGeneric = () => _jsx(ChangeContractInternal, {});
export const ChangeContractByModification = () => (_jsx(ChangeContractInternal, { typeOfChange: TypeOfChange.Modify }));
export const ChangeContractByTransfer = () => (_jsx(ChangeContractInternal, { typeOfChange: TypeOfChange.Transfer }));
export const ChangeContractByExtension = () => (_jsx(ChangeContractInternal, { typeOfChange: TypeOfChange.Extend }));
//# sourceMappingURL=ChangeContract.js.map